/* 0511ER — v7, Stufe 2 */
(function () {
  'use strict';

  /* Countdown: Ziel in ms aus data-countdown. Bei Ablauf ausblenden. */
  document.querySelectorAll('[data-countdown]').forEach(function (box) {
    var ziel = parseInt(box.getAttribute('data-countdown'), 10);
    if (!ziel) return;
    var f = {
      d: box.querySelector('[data-cd="d"]'), h: box.querySelector('[data-cd="h"]'),
      m: box.querySelector('[data-cd="m"]'), s: box.querySelector('[data-cd="s"]')
    };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var rest = ziel - Date.now();
      if (rest <= 0) { box.hidden = true; clearInterval(t); return; }
      var s = Math.floor(rest / 1000);
      f.d.textContent = pad(Math.floor(s / 86400));
      f.h.textContent = pad(Math.floor(s % 86400 / 3600));
      f.m.textContent = pad(Math.floor(s % 3600 / 60));
      f.s.textContent = pad(s % 60);
    }
    var t = setInterval(tick, 1000);
    tick();
  });

  /* Variantenauswahl: eine Auswahl je Option, echte Variant-ID ins Formular. */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var priceMapEl = root.querySelector('[data-variant-prices]');
    var idInput = root.querySelector('[data-variant-id]');
    var btn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var selects = root.querySelectorAll('select[data-option-index]');
    if (!jsonEl || !idInput || !selects.length) return;
    var product, prices = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    try { prices = JSON.parse(priceMapEl.textContent); } catch (e) {}

    function update() {
      var werte = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = product.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === werte[i]; });
      });
      if (!v) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-label-none');
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      if (priceEl && prices[v.id]) priceEl.textContent = prices[v.id];
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
})();
